import { KeyValueObj } from "@/common/types";
import { formatToNaira } from "@/common/utils/general";

export const invoiceTableHeaders = [
  "Invoice ID",
  "Invoice due Date",
  "Receiving Company",
  "Email",
  "Total Amount",
  "Amount Paid",
];

export const invoiceTableKeys = [
  "invoiceId",
  "dueDate",
  "receivingCompany",
  "email",
  "totalAmount",
  "amountPaid",
];

export const InvoiceFilterOptions = [
  {
    name: "amount_paid",
    label: "Amount Paid",
    type: "text",
  },
  {
    name: "total_amount",
    label: "Total Amount",
    type: "text",
  },
];

export function getInvoiceTableData(invoices: KeyValueObj[]) {
  const invoiceTable = invoices?.map((invoice: KeyValueObj) => ({
    id: invoice?.id,
    invoiceId: {
      type: "string",
      value: invoice?.invoice_number,
    },
    receivingCompany: {
      type: "string",
      value: invoice?.recipient?.name,
    },
    email: {
      type: "string",
      value: invoice?.recipient?.email,
    },
    amountPaid: {
      type: "string",
      value: formatToNaira(invoice?.amount_paid || 0),
    },
    dueDate: {
      type: "string",
      value: invoice?.invoice_due_date,
    },

    totalAmount: {
      type: "string",
      value: formatToNaira(invoice?.total_amount || invoice?.delivery_data?.total_amount),
    },
  }));
  return invoiceTable;
}
